import request from "@/utils/request";

// 创建推荐书目
export const createBook = (data) => {
    return request({
        url: "/businessservice/book/create",
        method: "post",
        data: data
    })
}

// 更新推荐书目
export const updateBook = (data) => {
    return request({
        url: "/businessservice/book/update",
        method: "post",
        data: data
    })
}

// 分页查询推荐书目
export const pageBook = (data) => {
    return request({
        url: "/businessservice/book/page",
        method: "post",
        data: data
    })
}

// 列表查询推荐书目
export const listBook = (data) => {
    return request({
        url: "/businessservice/book/list",
        method: "post",
        data: data
    })
}

// 查询推荐书目信息
export const  infoBook =(query) =>{
    return request({
        url: "/businessservice/book/info",
        method:"get",
        params: query
    })
}

// 删除推荐书目信息
export const  deleteBook =(query) =>{
    return request({
        url: "/businessservice/book/delete",
        method:"get",
        params: query
    })
}

// 提交讨论
export const submitBookDiscuss =(data) =>{
    return request({
        url: "/businessservice/book/createDiscuss",
        method:"post",
        data: data
    })
}

export const listBookDiscuss =(query) =>{
    return request({
        url: "/businessservice/book/listDiscuss",
        method:"get",
        params: query
    })
}

// 收藏或取消收藏
export const addOrCancelBook = (data) => {
    return request({
        url: "/businessservice/collect/addOrCancel",
        method: "post",
        data: data
    })
}

// 点赞
export const likeClickBook = (query) => {
    return request({
        url: "/businessservice/dp/like/click",
        method: "get",
        params: query
    })
}